import type { GnreStatus } from "@cx/contracts";
import { formatCollectionLine, type GnreKind, type GnreRevenue } from "@cx/domain";
import type { Tone } from "@cx/ui";

// ===== Rótulos das guias GNRE/DARE-SP (T2.11) =====

export const GNRE_STATUS_LABEL: Record<GnreStatus, string> = {
  pending: "Pendente de emissão",
  issued: "Emitida",
  paid: "Paga",
  canceled: "Cancelada",
};
export const GNRE_STATUS_TONE: Record<GnreStatus, Tone> = {
  pending: "warning",
  issued: "info",
  paid: "success",
  canceled: "secondary",
};
export const GNRE_REVENUE_LABEL: Record<GnreRevenue, string> = {
  st: "ICMS-ST",
  difal: "DIFAL",
  fcp: "FCP",
};
export const GNRE_KIND_LABEL: Record<GnreKind, string> = { gnre: "GNRE", dare_sp: "DARE-SP" };

/** "GNRE DIFAL — RJ". */
export const guideTitle = (g: { kind: GnreKind; revenue: GnreRevenue; uf: string }) =>
  `${GNRE_KIND_LABEL[g.kind]} ${GNRE_REVENUE_LABEL[g.revenue]} — ${g.uf}`;

/** Linha digitável de arrecadação em 4 blocos; fora do formato fica como veio. */
export const collectionLineLabel = (line: string | null) =>
  !line ? "—" : /^\d{48}$/.test(line) ? formatCollectionLine(line) : line;

/** "2026-10" → "10/2026". */
export const periodLabel = (p: string) => (/^\d{4}-\d{2}$/.test(p) ? `${p.slice(5)}/${p.slice(0, 4)}` : p);
